import { createContext } from 'react'
import { type CmsOptionsInput } from '@stuller/stullercom/data-access/apollo-queries'

const CmsContentOptionsContext = createContext<CmsOptionsInput>({})

export { CmsContentOptionsContext }
